import { useMemo, useState } from 'react'

import useSearch from '../../../../../../../../hooks/useSearch'

import { PRODUCTS_ADD_FILTERS_SEARCH } from '../AddProductBulkContent/AddProductBulkTable'

import { SELECTED_TAG } from '../../../../../../../../features/components/Filters/ProductTagsFilter'
import { SELECTED_LOCATIONS } from '../../../../../../../../features/components/DropdownFilters/components/LocationsFilter'
import { SELECTED_CATEGORIES } from '../../../../../../../../features/components/DropdownFilters/components/CategoriesFilter'
import { SELECTED_SUB_CATEGORIES } from '../../../../../../../../features/components/DropdownFilters/components/SubCategoriesFilter'
import { SELECTED_SUB_SUB_CATEGORIES } from '../../../../../../../../features/components/DropdownFilters/components/SubSubCategoriesFilter'
import { LOCATION_CATEGORIES } from '../../../../../../../../features/components/DropdownFilters/components/LocationCategoriesFilter'
import { LOCATION_REGIONS } from '../../../../../../../../features/components/DropdownFilters/components/LocationRegionsFilter'

const getParamsFromList = (list, key = 'value') => {
  return list
    .map(option => {
      if (option && option[key]) {
        return option[key]
      } else {
        return option
      }
    })
    .join(',')
}

export default function useProductsFilters(params) {
  const searchTerm = useSearch(PRODUCTS_ADD_FILTERS_SEARCH)

  const [filtersState, setFiltersState] = useState({
    [SELECTED_TAG]: '',
    [SELECTED_CATEGORIES]: [],
    [SELECTED_SUB_CATEGORIES]: [],
    [SELECTED_SUB_SUB_CATEGORIES]: [],
    [SELECTED_LOCATIONS]: [],
    [LOCATION_CATEGORIES]: [],
    [LOCATION_REGIONS]: []
  })

  const {
    [SELECTED_TAG]: selectedTag,
    [SELECTED_CATEGORIES]: selectedCategories,
    [SELECTED_SUB_CATEGORIES]: selectedSubCategories,
    [SELECTED_SUB_SUB_CATEGORIES]: selectedSubSubCategories,
    [SELECTED_LOCATIONS]: selectedLocations,
    [LOCATION_CATEGORIES]: locationCategories,
    [LOCATION_REGIONS]: locationRegions
  } = filtersState

  const requestParams = useMemo(() => {
    return {
      ...params,
      ...(searchTerm && { search: searchTerm }),
      ...(selectedTag && { tags: selectedTag }),
      ...(selectedCategories.length && { media_category: getParamsFromList(selectedCategories) }),
      ...(selectedSubCategories.length && { media_sub_category: getParamsFromList(selectedSubCategories) }),
      ...(selectedSubSubCategories.length && { media_sub_sub_category: getParamsFromList(selectedSubSubCategories) }),
      ...(selectedLocations.length && { location: getParamsFromList(selectedLocations) }),
      ...(locationCategories.length && { location_category: getParamsFromList(locationCategories) }),
      ...(locationRegions.length && { location_region: getParamsFromList(locationRegions) })
    }
  }, [
    params,
    searchTerm,
    selectedTag,
    selectedCategories,
    selectedSubCategories,
    selectedSubSubCategories,
    selectedLocations,
    locationCategories,
    locationRegions
  ])

  return useMemo(() => {
    return {
      filtersState,
      setFiltersState,
      requestParams
    }
  }, [filtersState, setFiltersState, requestParams])
}
